import { Show, For, createMemo } from 'solid-js'
import { characterStore } from '/web/store'
import PopularCard from '/web/shared/aifans/Cards/PopularCard'

interface Props {
  categorySlug?: string
  currentId?: string
}

const SuggestedCreators = (props: Props) => {
  const chars = characterStore((s) => ({ list: s.characters.list }))

  const suggestions = createMemo(() =>
    chars.list
      .filter((c) => props.categorySlug != null && c.categorySlug === props.categorySlug && c._id !== props.currentId)
      .slice(0, 4)
  )

  return (
    <Show when={suggestions().length > 0}>
      <section class="mx-auto w-full px-4 py-8 md:px-14 md:py-12">
        <h2 class="mb-2 font-clash text-2xl font-bold text-white md:text-[32px]">
          Profiles You Might Be Interested In
        </h2>
        <div class="mt-6 grid grid-cols-1 gap-6 md:mt-8 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4">
          <For each={suggestions()}>
            {(character) => (
              <PopularCard
                id={character._id}
                image={character.avatar}
                name={character.name}
                realName={character.realName}
                slug={character.slug}
                categorySlug={character.categorySlug}
              />
            )}
          </For>
        </div>
      </section>
    </Show>
  )
}

export default SuggestedCreators
